
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    planListing:[],
    planDetail:null
  };
  
  const planReducer = (state = initialState, action) => {
    // console.log("plan  reducers------", state,action);
   switch (action.type) {
     case "ADD_PLAN_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_PLAN_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_PLAN_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_PLAN_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_PLAN_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_PLAN_REQUEST_SUCCESS":
        return {
          ...state,
          planListing: action.payload,
          loading:false,
        };

      case "GOT_PLAN_DETAIL":  
      return {
        ...state,
        planDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default planReducer;
  